export default "__VITE_PUBLIC_ASSET__8f6f9293__"